import { deepExtract } from 'helpers/deep';

export class Venue {
  type = 'venue';

  constructor(data = {}) {
    Object.assign(this, {
      activities: data.activities,
      address: data.address,
      alias: data.alias,
      description: data.description,
      id: data.venue_id || data.id,
      images: data.images,
      location: data.location || {
        lat: data.lat,
        lon: data.lon,
      },
      locationName: deepExtract('location.name', data) || data.location_name || data.neighborhood,
      name: data.name || data.venue_name,
      rating: data.display_rating_average,
      ratingCount: data.display_rating_total,
      ratingMessage: data.rating_message,
      subtitle: data.subtitle,
      featuredReviews: data.featured_reviews,
    });
  }
}
